import { Box, Typography } from '@mui/material';

import {
  ActionProps,
  LinkAwareButton,
} from '../link-aware-button/link-aware-button';

export interface NoResultsOverrideType {
  mainText?: string;
  subText?: string;
  /**
   * The way out of the empty state — "Schedule a job", "Go to jobs". Give it
   * an `href` when it goes somewhere (it renders as a link), an `onClick`
   * when it opens something.
   */
  action?: ActionProps;
}

export function NoResultsText({
  textOverride,
}: {
  textOverride?: NoResultsOverrideType;
}) {
  return (
    <Box sx={{ py: 2, w: 1, textAlign: 'center' }}>
      <Typography variant="overline" align="center" fontSize="1.1rem">
        {textOverride?.mainText || 'No Results'}
      </Typography>
      <Typography variant="subtitle2" align="center" fontSize={'0.8rem'}>
        {textOverride?.subText !== undefined
          ? textOverride.subText
          : 'Try adjusting your filters'}
      </Typography>
      {textOverride?.action && (
        <EmptyStateAction action={textOverride.action} />
      )}
    </Box>
  );
}

function EmptyStateAction({ action }: { action: ActionProps }) {
  const { label, ...buttonProps } = action;
  return (
    <LinkAwareButton
      variant="contained"
      size="small"
      sx={{ mt: 1.5 }}
      {...buttonProps}
    >
      {label}
    </LinkAwareButton>
  );
}
